module.exports = __webpack_public_path__ + "img/logoHeader.07a4261f.png";